import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_REACT_APP_DB_URL
const BUG_REPORT_URL = process.env.NEXT_PUBLIC_BUG_REPORT_URL

///TODO SUPER HACKY, but we have no other way of quickly authorizing a token
///without refreshing it
const authorize = async (bearerToken) => {
    try {
        // Make request to the Ortho middleware to determine if the user is authorized
        const response = await get('/user_role/1', {
            headers: {
                'Authorization': bearerToken
            }
        })

        return response.data
    }
    catch (e) {
        console.log(e.message)
        console.log(e.stack)
        return createErrorResponse(e)
    }
}

const createErrorResponse = (error) => {

    const ERROR_CODE_CONNECTION_REFUSED = 1
    const ERROR_CODE_UNKNOWN_NO_REQUEST = 2

    if (error.response) {
        // RS-26602 Grab error message from response if available
        let responseData = error.response.data
        var message = error.response.status
        if (responseData) {
            if (responseData.message) {
                message = responseData.message
            } else if (responseData.data) {
                message = responseData.data
            }
        }
        return {
            error: {
                code: error.response.status,
                message: message
            }
        }
    }
    else if (error.request) {
        return {
            error: {
                code: ERROR_CODE_CONNECTION_REFUSED,
                message: 'Connection refused'
            }
        }
    }
    else if (error.message) {
        //  console.log("IG MEDIA RETURN ERR " + error.message)
        return {
            error: {
                code: ERROR_CODE_UNKNOWN_NO_REQUEST,
                message: error.message
            }
        }
    }
    else {
        return {
            error: {
                code: ERROR_CODE_UNKNOWN_NO_REQUEST,
                message: 'Unknown error. Request not sent'
            }
        }
    }

}

function logError(error) {
    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
    }
    else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
    }
    else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
    }

    console.log(error.config);
}

const put = (path, body = null, options = null) => {
    return axios.put(API_BASE_URL + path, body, options)
}

const post = (path, body = null, options = null) => {
    return axios.post(API_BASE_URL + path, body, options)
}

const get = (path, options = null) => {
    console.log("PATH IS " + (API_BASE_URL + path))
    return axios.get(API_BASE_URL + path, options)
}

const patch = (path, body = null, options = null) => {
    return axios.patch(API_BASE_URL + path, body, options)
}

// RS-20439 Added
const del = (path, options = null) => {
    console.log("PATH IS " + (API_BASE_URL + path))
    return axios.delete(API_BASE_URL + path, options)
}

// RS-15684
/**
 * Function to grab patient information based on patient identifier from middleware
 * 
 * @param {*} patientID Patient identifier to search for
 * @param {*} patientAppType App type the patient is using
 * @param {*} bearerToken Token for middleware calls TODO refactor this to be built int for all middleware calls
 * @returns 
 */
async function getPatient(patientID, patientAppType, bearerToken) {
    try {
        // Setup parameters for querying based on identifier
        const queryParams = {
            columns: ["identifier"],
            search: [patientID],
            limit: 1
        }
        // Header authorization TODO make baseline for all middleware calls
        const headers = {
            headers: {
                'Authorization': `Bearer ${bearerToken}`
            }
        }
        // TODO revert to no prior / when env gets updated
        const response = await post(`/patient/query`, queryParams, headers)

        // Grab search results first entry which should correspond to identifier specified or return error if none found
        let patient = response.data.data.results[0]
        if (patient.identifier == patientID) {
            patient.ortho_app = (patientAppType === "Ortho")
            return patient
        } else {
            return createErrorResponse({ message: "Patient Not Found" })
        }
    } catch (e) {
        console.log(e)
        return createErrorResponse(e)
    }
}

// RS-20439 Added
/**
 * Function to start twilio room in middleware for connecting to cardiac patient on ortho app
 * 
 * @param {int} patient_id patient to start twilio room for
 * @param {int} caller_id id of user creating room
 * @param {string} sid the sid to create room with
 * @param {string} bearerToken Token for middleware calls
 * @returns 
 */
async function startOrthoTwilioRoom(patient_id, caller_id, sid, bearerToken) {
    let result = createErrorResponse({message: "Patient is unavailable to call"})
    try {
        const queryParams = {
            patient_id: patient_id,
            identity: caller_id, 
            sid: sid, 
            cardiac_room: true
        }
        const headers = {
            headers: {
                'Authorization': `Bearer ${bearerToken}`
            }
        }
        // RS-20439 check that twilio patient is logged in first
        // Check whether patient we add is a ortho app patient and adjust accordingly
        const twilioRoomList = await getTwilioRoomList(retrievePractice(patient_id), bearerToken);
        // Check whether user is in twilioRoomlist
        if(twilioRoomList && isPatientInList(twilioRoomList, patient_id)) {
            const response = await post('/twilio_room/start', queryParams, headers)
            if(!response) {
                console.log(`Could not start call with patient_id: ${patient_id}`)
                result = createErrorResponse({message: "Could not start call with patient"})
            } else {
                result = response
            }
        }
    } catch(e) {
        console.log(e)
        // If expected response set error
        if(e && e.response && e.response.data && (e.response.data.data == 'Room creation failed.')) {
            result = createErrorResponse({message: "Patient in a call with another user"})
        } 
        // Otherwise give generic response
        else {
            result = createErrorResponse(e)
        }
    }
    return result
}

// RS-20439 Added
/**
 * Retrieve list of users available to call by twilio room 
 * @param {int} practice_id Practice id to search list in (unused until optimization ticket finishes)
 * @param {string} bearerToken Token for middleware calls 
 * @returns 
 */
async function getTwilioRoomList(practice_id, bearerToken) {
    // RS-20439 
    // Check if patient is also on twilio room list indicating its available for call on ortho app
    try {
        const queryParams = {
            practice_id: practice_id
        }
        const headers = {
            headers: {
                'Authorization': `Bearer ${bearerToken}`
            }
        }
        const response = await post('/twilio_room/list', queryParams, headers)
        let twilioList = response
        if(!twilioList) {
            console.log(`No Twilio Room List found for ${practice_id}`)
        } else {
            twilioList = response.data.data
        }
        return twilioList
    } catch(e) {
        console.log(e)
        return createErrorResponse(e)
    }
}

// RS-20439 Added
/**
 * Function to handle sending notifications for ortho app
 * @param {integer} patientId patient id to send notification too
 * @param {integer} team_member_id user id of sender
 * @param {integer} messageType type of notification being sent
 * @param {string} message string message sent with notification
 * @returns {mixed} res
 */
async function pushAppNotification(patientId, team_member_id, messageType, notificationMessage, bearerToken) {
    // Generate notification fields 
    let res = null;
    const paramData = {
        patient_id : patientId, 
        notification_type : messageType,
        sender_id : team_member_id, 
        message : notificationMessage
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    res = await post('/push_notification', paramData, headers)
    console.log('res', res)
    return res
}

// RS-20439 Added
/**
 * Check whether patient id is contained within provided list
 * @param {array} list list to check for given patient id
 * @param {integer} id patient id to check
 * @returns {boolean} found
 */
function isPatientInList(list, id) 
{
    let found = false
    if(list) {
        for(var i = 0; i < list.length; i++) {
            if(list[i].patient_id == id) {
                // Found patient id in list return early
                found = true 
                break
            }
        }
    }

    return found
}

// RS-20439 Added
/**
 * 
 * @param {integer} ortho_patient_id patient id for a patient on the ortho app
 * @param {string} bearerToken Token for middleware calls 
 * @returns 
 */
async function closeOrthoTwilioRoom(ortho_patient_id, bearerToken) {
    try {
        const headers = {
            headers: {
                'Authorization': `Bearer ${bearerToken}`
            }
        }
        const response = await del(`/twilio_room/end/${ortho_patient_id}`, headers)
        if(response) {
            console.log("Closed twilio room for patient " + ortho_patient_id)
        }
        // No action otherwise this is just to handle offcase where room is not closed properly from app end
        return response
    } catch(e) {
        console.log(e)
        return createErrorResponse(e)
    }
}

// RS-20439 
// TODO impliment this function when twilio room list optimization gets implimzented
async function retrievePractice(patient_id) {
    return 0
}

/**
 * Uploads a file to the bug report microservice
 * @param {*} bearerToken the bearer token to use for authorization
 * @param {*} file the file to upload
 * @returns the response from the bug report microservice
 */
async function uploadBugReportAttachment(bearerToken, file) {
    try {
        const formData = new FormData()
        formData.append('file', file)

        const response = await axios.post(BUG_REPORT_URL + "/Attachment", formData, {
            headers: {
                'Authorization': `Bearer ${bearerToken}`,
            }
        })
        console.log('uploadBugReportAttachment response: ', response)
        return response
    } catch (e) {
        console.log('uploadBugReportFiles error: ', e)
        return createErrorResponse(e)
    }
}

/**
 * Creates a bug report ticket via the bug report microservice
 * @param {*} bearerToken the bearer token to use for authorization
 * @param {*} requestBody the request body to send to the bug report microservice
 * @returns the response from the bug report microservice
 */
async function createBugReportTicket(bearerToken, requestBody) {
    try {
        const response = await axios.post(BUG_REPORT_URL + "/Ticket", requestBody, {
            headers: {
                'Authorization': `Bearer ${bearerToken}`
            }
        })
        console.log('createBugReportTicket response: ', response)
        return response
    }
    catch (e) {
        console.log('createBugReport error: ', e)
        return createErrorResponse(e)
    }
}

async function refreshToken(bearerToken) {
    try {
        const headers = {
            headers: {
                'Authorization': `Bearer ${bearerToken}`,
                'Content-Type': 'application/json',
            }
        };

        const resp = await post("/refresh", {}, headers);

        if (resp.status === 200) {
            console.log("resp", resp)
            return resp.data.data.access_token;
        } else {
            console.log("Could not refresh token", resp)
        }

    } catch (error) {
        console.log("Error refreshing token: ", error);
    }

    return null;
}

 /* Mark session as complete in middleware
 * @param {*} patientId
 */
async function completeSession(sessionId, protocolId, version, bearerToken) {
    // Format timestamp
    const time = new Date(Date.now()).toISOString()
    const timestamp = time.substring(0, time.lastIndexOf('.')) + '+00:00'

    const paramData = {
        protocol : protocolId, 
        time : timestamp,
        status : "CLOSED", 
        clientVersion : version
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await patch(`/result/${sessionId}`, paramData, headers)
    console.log('res', res)
    return res
}

async function selectOrInsertObserver(username, bearerToken) {
    const paramData = {
        username: username
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await post(`/cardiac/observer`, paramData, headers)
    console.log('res', res)
    return res
}

async function selectOrInsertObservedPatient(portalPatientId, patientName, bearerToken) {
    const paramData = {
        portal_patient_id: portalPatientId,
        patient_name: patientName
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await post(`/cardiac/observed_patient`, paramData, headers)
    console.log('res', res)
    return res
}

async function insertOrUpdatePatientObserver(patientId, observerId, bearerToken) {
    const paramData = {
        patient_id: patientId,
        observer_id: observerId
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await post(`/cardiac/patient_observer`, paramData, headers)
    console.log('res', res)
    return res
}

async function getActiveObservers(bearerToken) {
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await get(`/cardiac/observer/active`, headers)
    console.log('res', res)
    return res
}

async function setObserverActive(username, bearerToken) {
    const paramData = {
        username: username
    }
    const headers = {
        headers: {
            'Authorization': `Bearer ${bearerToken}`
        }
    }
    const res = await post(`/cardiac/observer/active`, paramData, headers)
    console.log('res', res)
    return res
}

async function logoutObserver(username, bearerToken) {
    //Using fetch API to keep request alive after page closes
    const res = fetch(API_BASE_URL + '/cardiac/observer/logout', {
        method:'post',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearerToken}`
        },
        body: JSON.stringify({
            username: username
        }),
        keepalive: true
    })
    console.log('res', res)
    return res
}

export const portalApi = {
    // RS-20439
    pushAppNotification,
    startOrthoTwilioRoom,
    getTwilioRoomList,
    closeOrthoTwilioRoom,
    getPatient,
    authorize,
    uploadBugReportAttachment,
    createBugReportTicket,
    refreshToken,
    selectOrInsertObserver,
    selectOrInsertObservedPatient,
    insertOrUpdatePatientObserver,
    getActiveObservers,
    setObserverActive,
    logoutObserver
}